module.exports = __webpack_public_path__ + "img/notifications.d158a17a.svg";